import { forwardRef } from "react";
import { TextBox, Tooltip } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import useTaskKey from "../../../hooks/useTaskKey";

export const TaskTypeKeyTextBox = forwardRef(
  ({ name, change, taskTypeName, ...rest }, ref) => {
    const { t } = useTranslation(["TaskTypes"]);
    const generatedKey = useTaskKey(taskTypeName);

    return (
      <>
        <div className="d-flex">
          <span className="task-type-label me-1">
            {t("CreateTaskTypeModal.TaskTypeKeyLabel")}
          </span>
          <Tooltip
            content={() => {
              return <span>{t("CreateTaskTypeModal.TaskTypeKeyTooltip")}</span>;
            }}
            openDelay={500}
            position="TopCenter"
            showTipPointer={false}
          >
            <i className={`fa-regular fa-circle-info icon`}></i>
          </Tooltip>
        </div>
        <TextBox
          ref={ref}
          id="task-type-txt-box"
          name={name}
          type="text"
          placeholder={generatedKey}
          showClearButton
          maxLength={3}
          change={(e) => {
            ref.current.setShowError(false);
            change(e);
          }}
          {...rest}
        ></TextBox>
      </>
    );
  }
);
